export enum TipoTrackingCorteEnum {
  DEFAULT = '',
  IMPREVISTO = 'IMPREVISTO',
  PROGRAMADO = 'PROGRAMADO',
}
